<template>
  <div>
    <transition name="slide-fade">
      <div class="fixed-panel" v-if="visible">
        <div class="item" :class="{'active': activeIndex === 0}" @mouseover="changeIndex(0)" @mouseleave="changeIndex(null)">
          <div class="item-text">企业微信</div>
          <div class="bubble-wrap" v-show="activeIndex === 0">
            <div class="bubble-box">
              <img class="qr-code" src="@assets/promotion-h5/qr-code.png" alt="">
            </div>
          </div>
        </div>
        <div class="item" :class="{'active': activeIndex === 1}" @mouseover="changeIndex(1)" @mouseleave="changeIndex(null)">
          <div class="item-text">商业合作</div>
          <div class="bubble-wrap" v-show="activeIndex === 1">
            <div class="bubble-box">
              <div class="phone-wrap">
                <div>电话：020-22330962</div>
                <div>邮箱：elieen.lee@vipshop.com</div>
              </div>

            </div>
          </div>
        </div>
        <div class="item" :class="{'active': activeIndex === 2}" @mouseover="changeIndex(2)" @mouseleave="changeIndex(null)">
          <div class="item-text">预约咨询</div>
          <div class="bubble-wrap" v-show="activeIndex === 2">
            <div class="bubble-box">
              <div class="contact-wrap">
                <div class="contact-item">
                  <div>公司名</div>
                  <input class="input-text" v-model="applyName" placeholder="请输入您的公司名" type="text">
                </div>
                <div class="contact-item">
                  <div>手机号</div>
                  <input class="input-text" v-model="applyPhone" placeholder="请输入您的手机号" type="number">
                </div>
                <div class="contact-tip" :class="{'visible': showTip}">{{showTip}}</div>
                <div class="contact-btn" @click="handleBook">预约咨询</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <SuccessDialog :visible.sync="isShowDialog" />
  </div>
</template>

<script>
import SuccessDialog from '@/components/SuccessDialog.vue'
import util from '@/utils'
import api from '@/lib/api'
import {encrypt} from '@/lib/encryptor'

export default {
  name: 'floatRight',
  components: {
    SuccessDialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      activeIndex: null,
      applyName: '',
      applyPhone: '',
      showTip: '',
      isShowDialog: false,
    }
  },
  methods: {
    changeIndex(index) {
      this.activeIndex = index
    },
    handleBook() {
      if (!this.applyName) {
        this.showTip = '请填入您的公司名'
        return
      }
      if (!this.applyPhone) {
        this.showTip = '请填入您的手机号'
        return
      }
      if (!util.validate('mobile', this.applyPhone)) {
        this.showTip = '手机号格式不正确'
				return
			}
      let data = {
        applyName: encrypt(this.applyName),
        applyPhone: encrypt(this.applyPhone),
      }
      api.applyChannel(data).then(() => {
        this.isShowDialog = true
        this.applyName = ''
        this.applyPhone = ''
      }).catch(err => {
        // util.toast(err.msg || err.message)
      })
    },
  }
}
</script>

<style lang="stylus" scoped>
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
.fixed-panel {
  position: fixed;
  right: 10rem;
  bottom: 130rem;
  width: 80rem;
  border-radius: 10rem;
  z-index: 99;
  // overflow: hidden;
  .item {
    position: relative;
    // border-bottom: 2rem solid #666666;
    border: 2rem solid #666;
    text-align: center;
    background: #fff;
    color: #333;
    z-index: 99;
    &:last-child {
      border-top: 0
      border-radius:  0 0 10rem 10rem;
    }
    &:first-child {
      border-bottom: 0;
      border-radius: 10rem 10rem 0 0;
    }
    

    &.active {
      background: #F90080;
      color: #fff;
      border-color: #F90080;
    }
    .item-text {
      cursor: pointer;
      width: 80rem;
      height: 80rem;
      font-size: 18rem;
      line-height: 22rem;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 20rem;
      box-sizing: border-box;
    }
    .bubble-wrap {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translate(-100%, -50%);
      .bubble-box {
        margin-right: 15rem;
        background: #fff;
        border-radius: 10rem;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;
        &::after {
          content: '';
          display: inline-block;
          position: absolute;
          right: 2rem;
          top: 50%;
          transform: translate(100%, -50%);
          width: 0;
          height: 0;
          border: 12rem solid transparent;
          border-left: 12rem solid #fff;
        }
      }
      .qr-code {
        margin: 15rem;
        width: 220rem;
        height: 220rem;
      }

      .phone-wrap {
        padding: 25rem 20rem;
        color: #333;
        font-size: 24rem;
        white-space: nowrap;
        line-height: 34rem;
        text-align: left;
      }

      .contact-wrap {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: space-between;
        width: 360rem;
        padding: 30rem;
        cursor: unset;

        .contact-item {
          display: flex;
          align-items: center;
          font-size: 22rem;
          color: #000;
          font-weight: bold;
          margin-bottom: 10rem;
          div {
            flex-shrink: 0;
          }
          .input-text {
            width: 280rem;
            height: 50rem;
            line-height: 50rem;
            margin-left: 10rem;
            border: 1px solid #979797;
            border-radius: 10rem
            color: #000;
            font-size: 22rem;
            outline-style: none;
            padding: 0 10rem;
            box-sizing: border-box;
            font-weight: normal;
            &::placeholder {
              color: #A3A3A3;
              font-weight: normal;
            }
          }
        }
        .contact-tip {
          height: 25rem;
          color: #999;
          font-size: 18rem;
          font-weight: 300;
          margin-left: 80rem;
          visibility: hidden;
          text-align: left;
        }
        .visible {
          visibility: visible;
        }
        .contact-btn {
          margin-top: 30rem;
          width: 100%;
          height: 50rem;
          line-height: 50rem;
          background: #F90080;
          border-radius: 25rem;
          color: #fff;
          font-size: 26rem;
          text-align: center;
          cursor: pointer;
        }
        input[type=number] {
          -moz-appearance:textfield;
        }
        input[type=number]::-webkit-inner-spin-button,
        input[type=number]::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/FloatRight.vue